<mat-card>
  <mat-card-content>
    <p class="mat-title">{{title()}}</p>
    <button *ngIf="!createMode()"
            mat-icon-button
            class="btn-delete-billing-mapping"
            (click)="deleteBillingMapping()">
      <mat-icon>delete</mat-icon>
    </button>

    <div class="component">

      <div class="inputs">
        <mat-form-field appearance="fill">
          <mat-label>Price</mat-label>
          <mat-select [(value)]="selectedPriceCategory" (valueChange)="onChangePrice()">
            <mat-option *ngFor="let cat of priceCategories" [value]="cat">
              {{cat.name}} - {{cat.priceCpm}} CPM
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Type</mat-label>
          <mat-select [(value)]="selectedType" (valueChange)="onChangePrice()">
            <mat-option *ngFor="let type of types" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-radio-group style="padding-left: 30px;" [(ngModel)]="publicSegment" *ngIf="createMode()" (change)="onChangePrice()">
          <mat-radio-button [value]="true">Public</mat-radio-button>
          <mat-radio-button [value]="false">Private</mat-radio-button>
        </mat-radio-group>

      </div>

      <div class="buttons" *ngIf="!xandrService.isDryMode">
        <button class="update" mat-stroked-button *ngIf="!createMode()" [disabled]="!btnUpdateEnabled()"
                (click)="updatePrice()">Update
          Price
        </button>
        <button class="create" mat-stroked-button *ngIf="createMode()" [disabled]="!btnCreateEnabled()"
                (click)="createPrice()">Create Price
        </button>
      </div>

    </div>
  </mat-card-content>
</mat-card>

<div *ngIf="loading" class="loading-progress-bar">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>

